import { ThunkAction } from "redux-thunk";
import { RootState } from "../store";
import { AnyAction } from "redux";
import MailingsService from "../services/mailings";
import {
  setErrorMessage,
  setSuccessMessage,
} from "./actionsCreators/messageActions";
import {
  ALL_EMAILS_WAS_DELETED,
  DELETE_USER_SUCCESS,
  EMAIL_CANCELED,
  SEND_SCHEDULED_SUCCESS,
} from "../lib/constants";

export const deleteEmail =
  (req: any): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      const res = await MailingsService.remove(req.id, req.type);

      dispatch(setSuccessMessage(DELETE_USER_SUCCESS));

      return await Promise.resolve(res);
    } catch (error: any) {
      dispatch(setErrorMessage(error.response.data.title, true));

      return await Promise.reject(error);
    }
  };

export const deleteAllEmails =
  (_: string): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      const res = await MailingsService.removeAll();

      dispatch(setSuccessMessage(ALL_EMAILS_WAS_DELETED));

      return await Promise.resolve(res);
    } catch (error: any) {
      dispatch(setErrorMessage(error.response.data.title, true));

      return await Promise.reject(error);
    }
  };

export const cancelEmail =
  (id: string): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      const res = await MailingsService.cancelEmail(id);

      dispatch(setSuccessMessage(EMAIL_CANCELED));

      return await Promise.resolve(res);
    } catch (error: any) {
      dispatch(setErrorMessage(error.response.data.title, true));

      return await Promise.reject(error);
    }
  };

export const rescheduleEmail =
  (
    id: string,
    request: any,
  ): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      const res = await MailingsService.update(id, request);

      dispatch(setSuccessMessage(SEND_SCHEDULED_SUCCESS));

      return await Promise.resolve(res);
    } catch (error: any) {
      const data = error.response.data;

      let err: string;

      if (data.errors) {
        const title: string = Object.keys(data.errors)[0];

        err = data.errors[title][0];
      } else {
        err = data.title;
      }

      dispatch(setErrorMessage(err, true));

      return await Promise.reject(error);
    }
  };
